import { Encoder } from '@everyboard/lib';
import { Coord } from './Coord';
import { Move } from './Move';
export class MoveWithTwoCoords extends Move {
    first;
    second;
    static getFallibleEncoder(generator) {
        return Encoder.tuple([Coord.encoder, Coord.encoder], (move) => [move.first, move.second], (fields) => generator(fields[0], fields[1]).get());
    }
    static getEncoder(generator) {
        return Encoder.tuple([Coord.encoder, Coord.encoder], (move) => [move.first, move.second], (fields) => generator(fields[0], fields[1]));
    }
    constructor(first, second) {
        super();
        this.first = first;
        this.second = second;
    }
    getFirst() {
        return this.first;
    }
    getSecond() {
        return this.second;
    }
    getCoords() {
        return [this.first, this.second];
    }
}
